import React from "react";
import {
  withStyles,
  Theme,
  WithStyles,
  createStyles,
} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "../components/Typography";
import Paper from "../components/Paper";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      marginTop: theme.spacing(8),
      marginBottom: theme.spacing(8),
    },
    paper: {
      padding: theme.spacing(4),
      borderLeft: `6px solid ${theme.palette.warning.main}`,
    },
  });

function WorkspaceAdminNotice(props: WithStyles<typeof styles>) {
  const { classes } = props;

  return (
    <Container className={classes.container}>
      <Paper background="light" className={classes.paper}>
        <Typography variant="h6" gutterBottom>
          Workspace Administrator Requirements
        </Typography>
        <Typography variant="body1" paragraph>
          Some organizations require approval from a Slack Workspace Owner or
          Administrator before a new third-party app can be installed.
        </Typography>
        <Typography variant="body1">
          If you're unable to connect a workspace, ask your Slack Workspace
          Owner or Administrator to approve or install the app named
          "Dubstatus", the name Dubslack's Slack integration appears under
          in Slack. This behavior is controlled entirely by
          your organization's Slack security settings, not by Dubslack.
        </Typography>
      </Paper>
    </Container>
  );
}

export default withStyles(styles)(WorkspaceAdminNotice);
